import { Box, Container, Grid, makeStyles, Typography } from "@material-ui/core";
import ContentLeft from "../component/ContentLeft";
import GioiThieu from "../component/GioiThieu";
const useStyles = makeStyles((theme) => ({
    container: {
        marginTop: theme.spacing(4),
    }
}));


export default function GioiThieuPage() {
    const classes = useStyles();
    return (
        <Container maxWidth="lg" className={classes.container}>
            <Grid container spacing={2}>
                <Grid item md={3} xs={12} >
                    <ContentLeft />
                </Grid>
                <Grid item md={9} xs={12} >
                    <GioiThieu />
                </Grid>
            </Grid>
        </Container>

    );
}